import {Link} from 'react-router-dom'
import dicpic from './images/diccard.png'
import transpic from './images/transcribe.png'
import transpics from './images/translate.png'
import chat from './images/chatgpt.png'
function Home(){
return(
    <div>
    <main className="mb-2">
           
          
            <div className="container cont ">

                <div className="row">
                    <div className ="col-12 col-sm-3 ml-auto">
                    <div className="card my-1 " >
                            <img className="card-img-top" src={dicpic} alt="Card image cap"/>
                            <hr/>
                            <div className="card-body">
                                <h5 className="card-title">DDAI DICTIONARY</h5>
                                <p className="card-text"> DDAI Dictionary, find a meaning for any words.</p>
                                <Link to="/dict" className="btn btn-warning ">Use DDAI Dictionary</Link>
                             </div>
                        </div> 
                      
                    </div>

                   

                       <div className ="col-12 col-sm-3 ">
                    <div className="card my-1" >
                            <img className="card-img-top" src={transpics} alt="Card image cap"/>
                            <hr/>
                            <div className="card-body">
                                <h5 className="card-title">DDAI TRANSLATION </h5>
                                <p className="card-text">DDAI TRANSLATION, convert text written in other lanagues to English. </p>
                                <Link to="/translate" className="btn btn-warning">Use DDAI Translation</Link>
                             </div>
                        </div> 
                    </div>
                    
                    <div className ="col-12 col-sm-3 ">
                    <div className="card  my-1" >
                            <img className="card-img-top" src={transpic} alt="Card image cap"/>
                            <hr/>
                            <div className="card-body">
                                <h5 className="card-title">DDAI Quote Generator</h5>
                                <p className="card-text">DDAI Quote Generator, find quotes for your content.</p>
                                <Link to="/transcribe" className="btn btn-warning"> DDAI Quote Generator</Link>
                             </div>
                        </div> 
                    </div> 
                    <div className ="col-12 col-sm-3 ">
                    <div className="card my-1" >
                            <img className="card-img-top" src={chat} alt="Card image cap"/>
                            <hr/>
                            <div className="card-body">
                                <h5 className="card-title">DDAI Image generator using Open AI</h5>
                                <p className="card-text">Ask anything you want!</p> <br/>
                                <Link to="/imagegenerate" className="btn btn-warning">Find answer interms of images</Link>
                             </div>
                        </div> 
                    </div>
                </div>
               
            

                

            </div>



            </main>
           
            </div>
)

}

export default Home;